import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import ActivityComponentMap from "~/constants/ActivityComponentMap";

const Activity = ({
  lead,
  activity,
  activityId = null,
  activeTab = "all",
  setCurrentFormWithData,
  toggleActivityInternal,
  removeActivity,
  isHighlighted = false,
  isHighlightFading = false,
  // Pin props (passed through to activity component)
  isPinned,
  isAtLimit,
  pinnedCount,
  onPinToggle,
  canPin,
  canUnpin,
  isPinLoading,
}) => {
  const ActivityComponentInfo = ActivityComponentMap[activity.key];

  if (!ActivityComponentInfo) {
    return (
      <div
        key={activity.id}
        id={`activity-${activity.id}`}
        className={classNames("mt15", "mb15", "timeline-activity-wrapper", {
          "activity-highlighted": isHighlighted,
          "activity-highlight-fading": isHighlightFading,
        })}
      >
        <p className="text-grey">
          Missing activity timeline for{" "}
          <code className="text-red">{activity.key}</code>
        </p>
      </div>
    );
  }

  const { Component: ActivityComponent, props: activityProps = {} } =
    ActivityComponentInfo;
  const activityKey = `activity-${activity.id}-${activity.updated_at}`;

  const allProps = useMemo(
    () => ({
      activity,
      lead,
      activityId,
      activeTab,
      ...activityProps,
      setCurrentFormWithData,
      toggleActivityInternal,
      removeActivity,
      ...(onPinToggle !== undefined && {
        isPinned,
        isAtLimit,
        pinnedCount,
        onPinToggle,
        canPin,
        canUnpin,
        isPinLoading,
      }),
    }),
    [
      activity,
      lead,
      activityId,
      activeTab,
      activityProps,
      setCurrentFormWithData,
      toggleActivityInternal,
      removeActivity,
      onPinToggle,
      isPinned,
      isAtLimit,
      pinnedCount,
      canPin,
      canUnpin,
      isPinLoading,
    ],
  );

  return (
    <div
      id={`activity-${activity.id}`}
      className={classNames("timeline-activity-wrapper", {
        "activity-highlighted": isHighlighted,
        "activity-highlight-fading": isHighlightFading,
      })}
    >
      <ActivityComponent key={activityKey} {...allProps} />
    </div>
  );
};

Activity.propTypes = {
  lead: PropTypes.shape({}).isRequired,
  activity: PropTypes.shape({
    id: PropTypes.number.isRequired,
    key: PropTypes.string.isRequired,
    updated_at: PropTypes.string.isRequired,
  }).isRequired,
  activityId: PropTypes.number,
  activeTab: PropTypes.string,
  setCurrentFormWithData: PropTypes.func.isRequired,
  toggleActivityInternal: PropTypes.func.isRequired,
  removeActivity: PropTypes.func.isRequired,
  isHighlighted: PropTypes.bool,
  isHighlightFading: PropTypes.bool,
};

export default Activity;
